
webpack.register(
    'blocks/dfp-advert-unit/dfp-advert-unit',
    function() {
        return import('blocks/dfp-advert-unit/dfp-advert-unit');
    },
    true
);